const zIndex = {
	menu: 9,
	header: 10,
	socialMediaLinks: 10,
	routeTransitionEffect: 99,
	entryMask: 100
};

export default zIndex;
